import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaArrowLeft } from 'react-icons/fa';
import CustomButton from '../CustomButton';
import './VerifyProfileInfoModal.css';

const VerifyProfileInfoModal = ({ show, onHide, onVerifyNow }) => {
  const handleBack = () => {
    onHide();
  };

  return (
    <Modal show={show} onHide={handleBack} centered className="verify-profile-info-modal">
      <Modal.Body className="verify-profile-info-modal-body">
        <div className="verify-profile-info-content pt-4">
          {/* Header */}
          <div className="verify-profile-info-header">
            <button className="back-button" onClick={handleBack}>
              <FaArrowLeft />
            </button>
            <h4 className="verify-profile-info-title">Verify Your Profile</h4>
          </div>

          {/* Description */}
          <div className="verify-profile-info-description">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.
            </p>
          </div>

          {/* Get More Responses Section */}
          <div className="verify-profile-benefits">
            <h5 className="benefits-title">Get More Responses:</h5>
            <p className="benefits-text">Show that you are Real.</p>
          </div>

          {/* Verify Now Button */}
          <div className="verify-profile-actions">
            <CustomButton
              onClick={onVerifyNow}
            >
              Verify Now
            </CustomButton>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VerifyProfileInfoModal;

